module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-900.370d569f.eot";